<style lang="scss">
.beat-container{
    .item {
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 0px !important;
    }

    .shadow {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 0;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        z-index: 1;
        opacity: 0;
        cursor: pointer;
    }

    .featured-shadow {
        border-bottom-right-radius: 5px !important;
        border-bottom-left-radius: 5px !important;
    }

    .boxed{
        background-image: linear-gradient(135deg, #8f40b0 0%, #642d7b 100%);
        opacity: 0.6;
    }

    .item-overlay{
        z-index : 4;
        margin-top: -23px !important;
        margin-left: -23px !important;
        cursor: pointer;
        opacity: 1;
    }

    .text-gradient-background {
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 38%;
        border: 0;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        z-index: 1;
        cursor: pointer;
        opacity: 0.3;

        &-top {
            top: -6px;
            background-image: linear-gradient(to top, transparent 0%, black 100%);
        }

        &-bottom {
            bottom: -6px;
            background-image: linear-gradient(to bottom, transparent 0%, black 100%);
        }

    }

    .item-media{
        border-width: 1px;
        border-style: solid;
        border-radius: 5px 5px 0 0;

        &.media-featured{
            border: none;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.16) !important;
            border-bottom-right-radius: 5px !important;
            border-bottom-left-radius: 5px !important;
        }
    }

    .item-info{
        z-index : 3;
        .genre {
            text-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
            color: #ffffff;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 400;
        }

        .featured-genre {
            color: #c8c8c8;
            font-family: Poppins;
            font-size: 11px;
            font-weight: 400;
            margin-top: 5px;
            margin-bottom : 5px;
        }

        .item-title {
            text-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
            color: #ffffff;
            font-size: 18px !important;
            font-weight: 600;
            background: none !important;
            display: flex !important;
            flex-direction: column !important;
            text-overflow : ellipsis;
            a {
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }


        .divider {
            border-bottom-width: 1px;
            border-bottom-style: solid;
        }

        .item-info-overlay{
            background: none !important;
        }

        .price-wrapper{
            position: absolute;
            bottom: 10px;
            right: 20px;
        }


    }
    .tile-item-info{
        padding: 0 !important;
        border-radius: 0px 0px 5px 5px;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        background-color: #ffffff;
        color: #363C43;


        .featured-genre {
            margin-top: .1rem;
            margin-bottom: 0;
        }

        .tile-item-title{
            font-size: 14px !important;
            font-weight: 600;
            display: flex !important;
            flex-direction: column !important;
            text-overflow : ellipsis;
            padding: .25rem 1rem;
            text-align: center;
            a {
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .tile-price-wrapper{
            color: #ed215f;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 300;
            padding: .7rem;
            text-align: center;
            border-radius: 0 0 5px 5px;
            .price{
                position: absolute;
                right: 0px;
                margin-right: 12px;
            }
        }
    }
    .btn-playpause {
        background: #fff;
        color: #ff5b94;
        position: absolute !important;
        top: 3px !important;
        left: 3px !important;
        padding: 0 0px !important;
        font-size: 16px;
    }

    .quarter {
        width: 23px;
        height: 23px;
        background-color: #ffffff;
        opacity: 0.52;
    }

    .top-right {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 3px;
        border-top-left-radius: 3px;
        position: absolute;
        right: 0;
        top: 0;
    }

    .bottom-left {
        border-bottom-left-radius: 40px;
        position: absolute;
        border-top-left-radius: 3px;
        border-bottom-right-radius: 3px;
        bottom: 0;
        left: 0;
    }

    #circle-container {
        width: 46px;
        height: 46px;
        position:relative;
        z-index:5;
    }
}

</style>

<template>
<div class="beat-container">
    <div class="item" :style="$musicContainerShadow" :class="{'active': active}">
        <div class="item-media" @mouseover="hover(true)" @mouseleave="hover(false)" :class="{'media-featured': featured}" :style="!featured ? $itemTileBorderStyle : {}">
            <div v-if="featured" class="text-gradient-background text-gradient-background-top" @click="play()"></div>
            <div v-if="featured" class="text-gradient-background text-gradient-background-bottom" @click="play()"></div>
            <div class="shadow" @click="play()" :class="{'boxed': hovered , 'featured-shadow' : featured}" :style="$musicContainerOverlayStyle"></div>
            <router-link :to="{name: 'beat', params: {beat: beat.alias}}" class="item-media-content"
                         :style="{'background-image': 'url(' +  beat.image(imageSize) + ')'}"></router-link>
            <div class="item-overlay center" @click="play()">
                <div id="circle-container" v-show="hovered">
                    <div class="quarter top-right" :style="$itemPlayButtonStyle"></div>
                    <div class="quarter bottom-left" :style="$itemPlayButtonStyle"></div>
                    <button v-if="isPlaying && !isPaused" class="btn-playpause" :style="$itemPlayButtonStyle"  @click.stop="beat.pause()">
                        <font-awesome-icon icon="pause"></font-awesome-icon>
                    </button>
                    <button v-if="(!isPlaying && isPaused) || (!isPlaying && hovered)" class="btn-playpause"  :style="$itemPlayButtonStyle" @click.stop="beat.play()">
                        <font-awesome-icon icon="play"></font-awesome-icon>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="featured" @mouseover="hover(true)" @mouseleave="hover(false)" class="item-info" @click="play()">
            <div class="item-title text-ellipsis">
                <router-link @click.native.stop="" :to="{name: 'beat', params: {beat: beat.alias}}">{{beat.name}}</router-link>
                <span class="genre">{{beat.genre.name}}</span>
            </div>
            <div class="price-wrapper">
                <buy-button :item="beat"
                            variant="overImage"
                            v-if="showPrice && beat.minPrice() > 0"></buy-button>
            </div>
        </div>

        <div v-else class="tile-item-info item-info" :style="$itemTileStyle">
            <div class="tile-item-title text-ellipsis" v-if="!featured">
                <router-link @click.native.stop="" :to="{name: 'beat', params: {beat: beat.alias}}">{{beat.name}}</router-link>
                <span class="featured-genre" :style="$itemTileSecondaryTextStyle">{{beat.genre.name}}</span>
            </div>
            <div class="divider" :style="$itemTileBorderStyle"></div>
            <buy-button :item="beat"
                        variant="itemTileButton"
                        v-if="showPrice && beat.minPrice() > 0"></buy-button>
            <router-link v-else class="c-button c-button--for-item-tile" :to="{name: 'beat', params: {beat: beat.alias}}" :style="$itemTilePriceStyle"  @click.stop>
                <font-awesome-icon class="c-button__left-icon" icon="info-circle"></font-awesome-icon>View Details
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
    import Configure from '../mixins/configure'
    import DownloadButton from './downloadbutton.vue'
    import BuyButton from './shared/buy-button.vue'

    export default {
        props: {
            'beat': {
                type: Object,
                required: true
            },
            'display': {
                type: String,
                default: 'block'
            },
            'showPrice': {
                type: Boolean,
                default: false
            },
            'showDownload': {
                type: Boolean,
                default: false
            },
            'showMeta': {
                type: Boolean,
                default: false
            },
            'imageSize': {
                type: [Number, String],
                default: 100
            },
            'featured': {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.$data.$display = this.display
        },
        mounted() {
            this.licenseModal = $("#buyLicenseModal")
        },
        components: {
            DownloadButton, BuyButton
        },
        data() {
            return {
                licenseModal: null
            }
        },
        computed: {
            minPrice() {
                return this.beat.minPrice()
            },
            active() {
                if (this.currentlyPlayingItem == this.beat) {
                    this.$data.$active.musicContainer = true
                    return true
                }

                this.$data.$active.musicContainer = false
                return false
            },
            playerActive() {
                return this.$store.state.player.playing
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            isPlaying() {
                return (this.playlistManager.isPlaying(this.beat) && this.playerActive)
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.beat) && !this.playerActive)
            },
            hovered(){
                if(this.isPlaying || this.isPaused || this.$data.$hover.musicContainer){
                    return true;
                }
                return false;
            }
        },
        mixins: [Configure],
        methods: {
            hover(isHovering) {
                this.$data.$hover.musicContainer = isHovering
            },
            buyBeat() {
                this.$store.commit("buyableBeat", {beat: this.beat})

                this.licenseModal.modal("show")
            },
            play(){
                if(this.isPlaying){
                    this.beat.pause()
                }else{
                    this.beat.play()
                }
            }
        }
    }
</script>